<template>
    <section>
        <v-menu
        max-height='40%'
        max-width='30%'
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        offset-x
        bottom
        >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            small dark 
            :color="(valuesList.filter(item => item.enable ? true : false).length > 0) ? 'deep-purple darken-3' : bgcolor"
            v-bind="attrs"
            v-on="on"
            >
            {{label}}
            <span v-for="(item,index) in valuesList.filter(item => item.enable ? true : false)" :key="index">
                <span v-if="(index<=0)">
                    &nbsp;: {{item['value']}} 
                </span>
                <span v-if="(index==1)">
                    [+{{(valuesList.filter(item => item.enable ? true : false).length - 1)}}] 
                </span>
            </span>
            <!-- <span v-if="(filteredItems.filter(item => item.enable ? true : false).length > 0)">
                &nbsp;: {{filteredItems.filter(item => item.enable ? true : false).length}} Selected
            </span> -->
        </v-btn>
      </template>
      <v-list >
        <v-text-field
            outlined
            :color="textFieldOutline"
            label="Search"
            class="pa-2 pb-0"
            v-model="search"
        ></v-text-field>
        <hr>
        <v-list-item v-for="(item1,index) in filteredItems" :key="index">
            <v-checkbox v-model="item1['enable']" :label="item1['value']" @click="emitvaluesList"></v-checkbox>
        </v-list-item>
    </v-list>
    </v-menu>
    </section>
</template>

<script>
import Vue from 'vue';
export default {
    name:'menudropdown',
    data(){
        return{
            menu : false,
            search: '',
            selectedList: this.selectedValues,
            selectAllStatus: false
        }
    },
    props:{
        label : {
            type : String
        },
        bgcolor : {
            type : String
        },
        valuesList: {
            type:Array,
            default() {
                return []
            }
        },
        selectedValues : {
            type:Array,
            default() {
                return []
            }
        },
        textFieldOutline: {
            type : String
        }
    },
    created(){
        
    },
    computed:{
        filteredItems() {
            return this.valuesList.filter((item) =>{return item.value.match(this.search) || item.value.toLowerCase().match(this.search.toLowerCase())})
     }
    },
    watch:{
        selectedList(){
            this.$emit('selectedValuesList',this.selectedList)
        },
        selectedValues(){
            this.selectedList = this.selectedValues
        }
    },
    methods:{
        emitvaluesList(){
            // console.log(this.valuesList)
            this.$emit('selectedValuesList',this.valuesList)
        },
        selectAll(){
            var self =this;
            if (self.selectAllStatus) {
                self.selectedList = [];
                self.selectAllStatus = false;
            } else if(!self.selectAllStatus){
                for(let value in self.valuesList){
                    self.selectedList.push(self.valuesList[value]['key'])
                }
                self.selectAllStatus = true;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.chipsclass{
    max-width:5rem;
}
.chipsclass span{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections, .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
    min-height: unset !important;
}
</style>